import { FeedbackTab } from '@chegg-wt/core-wa/constants/paraphraser'
import {
  ChangeType,
  Feedback,
  FeedbackType,
  PaperStatus,
  PaperType,
  QuickActionPanelType,
} from '@chegg-wt/core-wa/types'
import { Dispatch, SetStateAction } from 'react'

export interface SentenceOffset {
  id: string
  offset: number
  length: number
  originalText: string // local variable only, will not be stored in db
  lastUpdated: number
}

export enum ToastType {
  FLAG = 'flag',
  COPY = 'copy',
  GRAMMAR_ERROR = 'grammar:error',
  CLARITY_ERROR = 'clarity:error',
  QUICK_ACTION_RETRY_ERROR = 'quickActionRetryError:error',
  CLARITY_REASON_ERROR = 'clarity_reason:error',
  SAVING_PAPER = 'saving:paper',
  DRAFT_PAPER_EXISTS = 'draft-exists:paper',
  SAVING_PAPER_ERROR = 'saving:paper:error',
}

export interface ParaphraserState {
  paraphraseFlag: boolean
  sentenceOffsets: SentenceOffset[]
  feedbackList: Feedback[]
  fetchNewSentencesLoading: boolean
  isPaperCheckInProgress: boolean
  rewritePanelSentences: SentenceOffset[]
  quickActionPanelType: QuickActionPanelType | null
  activeFeedbackTab: FeedbackTab
  activeFeedbackCardId: string | null
  isTimedOut: boolean
  totalFeedbackCount: number
  paperId?: string
  paperTitle: string
  paperStatus: PaperStatus
  requiresReCheck: boolean // Using the same name as in DB
  wordCount: number
  toastType: ToastType | null
  isNewDocumentRequested: boolean
  undoEnabled: boolean
  redoEnabled: boolean
  isTransferOfOwnershipInProgress: boolean
  paperList: PaperType[]
  isLoggingOut: boolean
}

interface PusherGrammarSuggestions {
  id: string
  reason: string
  changeType: ChangeType
  position: {
    offset: number
    length: number
  }
  suggestedText: string
}

export interface PusherGrammarFeedback {
  // for grammar only
  suggestions: PusherGrammarSuggestions[]
  feedbackType: FeedbackType.GRAMMAR
}
export interface PusherParaphraseFeedback {
  id: string
  score: number
  suggestedText: string
  feedbackType: FeedbackType.PARAPHRASE
  reason?: string // In actual we will not get reason single pusher feedback data. But reason may be added in cache which is using this same type
}

export interface PusherSynonymsFeedback {
  feedbackType: FeedbackType.SYNONYM
  position: {
    offset: number
    length: number
  }
  synonyms: string[]
}

export interface PusherClarityReasonFeedback {
  feedbackType: FeedbackType.CLARITY_REASON
  reason: string
}

export type ErrorData = {
  code: string
  message: string
}

export type WtPusherEvent<
  K =
    | PusherGrammarFeedback
    | PusherParaphraseFeedback
    | PusherSynonymsFeedback
    | PusherClarityReasonFeedback
> = {
  sentence: { id: string }
  initiatedAt: string
  checkType: any
  feedback: K
  error?: ErrorData
}

export enum ProofReaderCardActions {
  ACCEPT = 'accept',
  REJECT = 'reject',
  CLICK = 'click',
  REGENERATE = 'regenerate',
  FLAG = 'flag',
}

export type SetError = Dispatch<SetStateAction<ErrorData>>
export type SetIsLoadingSuggestions = Dispatch<SetStateAction<boolean>>
export type SetIsLoading = Dispatch<SetStateAction<boolean>>
